import React from 'react';
import PropTypes from 'prop-types';

import SaveIcon from '@mui/icons-material/Save';

import { Box, IconButton, TextField } from '@mui/material';

import MapIcon from '@mui/icons-material/Map';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { isEmpty } from 'lodash';
import ShowListIconsFontawesome from '../../components/ShowListIconsFontawesome';
import { LIBRARY_ICON_TYPES } from '../../../api/AnnotationTemplates/AnnotationTemplates';

const MapsAdvancedMapDeckField = props => {
  const { listComponentsAdvanced, setListComponentsAdvanced } = props;
  const [nameComponent, setNameComponent] = React.useState(
    listComponentsAdvanced.ShowMapDeckLidarComponent.name
  );
  const [openModal, setOpenModal] = React.useState(false);
  const [iconFontawesome, setIconFontawesome] = React.useState(
    listComponentsAdvanced.ShowMapDeckLidarComponent.iconFontawesome
  );
  const [iconSvg, setIconSvg] = React.useState(
    listComponentsAdvanced.ShowMapDeckLidarComponent.iconSvg
  );
  const [libraryIcon, setLibraryIcon] = React.useState(
    listComponentsAdvanced.ShowMapDeckLidarComponent.libraryIcon
  );

  const handleIconSelected = (elementIcon, library) => {
    if (library === LIBRARY_ICON_TYPES.FONTAWESOME) {
      setIconFontawesome(elementIcon);
      setListComponentsAdvanced({
        ...listComponentsAdvanced,
        ShowMapDeckLidarComponent: {
          name: listComponentsAdvanced.ShowMapDeckLidarComponent.name,
          show: listComponentsAdvanced.ShowMapDeckLidarComponent.show,
          iconFontawesome: elementIcon,
          libraryIcon: library
        }
      });
    }

    if (library === LIBRARY_ICON_TYPES.SVG) {
      setIconSvg(elementIcon.url);
      setIconFontawesome(elementIcon.name);
      setListComponentsAdvanced({
        ...listComponentsAdvanced,
        ShowMapDeckLidarComponent: {
          name: listComponentsAdvanced.ShowMapDeckLidarComponent.name,
          show: listComponentsAdvanced.ShowMapDeckLidarComponent.show,
          iconFontawesome: elementIcon.name,
          iconSvg: elementIcon.url,
          libraryIcon: library,
          cetegorySvg: elementIcon.category
        }
      });
    }
    setLibraryIcon(library);
  };
  return (
    <Box display="column" width="50%" gab={1}>
      <Box
        component="form"
        sx={{
          display: 'flex',
          mb: 2,
          width: '100%'
        }}
        noValidate
        autoComplete="off"
      >
        <TextField
          id="outlined-required"
          label="Nombre del componente"
          size="small"
          value={nameComponent}
          onChange={event => setNameComponent(event.target.value)}
          mb={2}
          fullWidth
        />
        <IconButton
          onClick={() => setOpenModal(true)}
          style={{
            color: '#2A3F90'
          }}
        >
          {!isEmpty(libraryIcon) ? (
            <>
              {libraryIcon === LIBRARY_ICON_TYPES.FONTAWESOME && (
                <FontAwesomeIcon icon={iconFontawesome} />
              )}
              {libraryIcon === LIBRARY_ICON_TYPES.SVG && (
                <img
                  src={iconSvg}
                  alt={iconFontawesome}
                  style={{ marginRight: '5px', width: '20px', height: '20px' }}
                />
              )}
            </>
          ) : (
            <MapIcon />
          )}
        </IconButton>
        <IconButton
          onClick={() =>
            setListComponentsAdvanced({
              ...listComponentsAdvanced,
              ShowMapDeckLidarComponent: {
                name: nameComponent,
                show: listComponentsAdvanced.ShowMapDeckLidarComponent.show
              }
            })
          }
          style={{
            color: '#2A3F90'
          }}
        >
          <SaveIcon />
        </IconButton>
        <ShowListIconsFontawesome
          openModal={openModal}
          setOpenModal={setOpenModal}
          handleIconSelected={handleIconSelected}
          selectedIcon={listComponentsAdvanced.ShowMapDeckLidarComponent.iconFontawesome}
          startLibrary={listComponentsAdvanced.ShowMapDeckLidarComponent.libraryIcon}
          svg={listComponentsAdvanced.ShowMapDeckLidarComponent.iconSvg}
          startCategorySvg={listComponentsAdvanced.ShowMapDeckLidarComponent.cetegorySvg}
        />
      </Box>
    </Box>
  );
};
export default MapsAdvancedMapDeckField;
MapsAdvancedMapDeckField.defaultProps = {
  setListComponentsAdvanced: () => {}
};
MapsAdvancedMapDeckField.propTypes = {
  listComponentsAdvanced: PropTypes.object.isRequired,
  setListComponentsAdvanced: PropTypes.func
};
